export const projects = [
  {
    title: "Freelance Website",
    subtitle: "Bootstrap, HTML, CSS",
    description:
      "A website I designed and built for a startup company in the education sector. Used Bootstrap Carousel template and customized styles. Deployed using Github Pages and GoDaddy domain.",
    image: "./ed-mgmt-gif.gif",
    link: "https://www.edu-mgmt.com/",
    github_link: "https://github.com/shauncy777/ed_mgmt",
  },
  {
    title: "SQL Database",
    subtitle: "Javascript, Node.JS, Express, SQLite, Sequelize, Pug",
    description:
      "This is an application that implements a browser interface to allow users to carry out CRUD operations on a SQLite Database. Take a look at the Github Repo!",
    image: "./database-capture.gif",
    link: "https://github.com/shauncy777/project-8",
    github_link: "https://github.com/shauncy777/project-8",
  },
  {
    title: "Phrase Hunter",
    subtitle: "Javascript, CSS, HTML, OOP",
    description:
      "This is a word guessing game that displays a random, hidden phrase, which a player tries to guess by clicking letters on an onscreen keyboard.",
    image: "./phrase-capture.gif",
    link: "https://shauncy777.github.io/Project_4_game_show/",
    github_link: "https://github.com/shauncy777/Project_4_game_show",
  },
  {
    title: "Data Pagination and Filtering",
    subtitle: "JavaScript, CSS, HTML",
    description:
      "Program that allows users to click through multiple pages of student data by filtering as user types into search field  and has a pagination feature that returns results and diplays 9 items per page.",
    image: "./pag-capture.gif",
    link: "https://shauncy777.github.io/data-pagination-and-filtering-project2/",
    github_link: "https://github.com/shauncy777/data-pagination-and-filtering-project2",
  },
  {
    title: "Public API Requests",
    subtitle: "Javascript,CSS, HTML, Fetch and Public APIs, OOP",
    description:
      "A Random User Generator API is used to grab information for 12 random “employees,” and builds a prototype for an employee directory. Also has filtering feauture.",
    image: "./api-capture.gif",
    link: "https://shauncy777.github.io/project_5/",
    github_link: "https://github.com/shauncy777/project_5",
  },
  {
    title: "Random Quote Generator",
    subtitle: "JavaScript, CSS, HTML",
    description:
      "A color changing quote generator that provides a new quote with each button click. This program utilizes functions and conditional statements to iterate an array of objects and print them to the screen.",
    image: "./quote-capture.gif",
    link: "https://codepen.io/shawn-daugherty-calhoun/full/eYgEYMw",
    github_link: "https://github.com/shauncy777/Techdegree-project-1",
  },
  {
    title: "Personal Portfolio",
    subtitle: "Express.js, Node, Pug, JavaScript, CSS, HTML",
    description:
      "This is a portfolio site to showcase the projects I've built. The site contains a modern landing page, an about page where I share contact info and give a little background and a series of project pages from the TeamTreehouse Techdegree.",
    image: "./portfolio-capture.gif",
    link: "https://shauncy-portfolio.herokuapp.com/",
    github_link: "https://github.com/shauncy777/project-6-portfolio",
  },
  {
    title: "Interactive Web Form",
    subtitle: "JavaScript, CSS, HTML",
    description:
      "An interactive registration form for a fictional Full Stack conference which uses JavaScript to enable conditional behavior and interactivity by validating user input and providing helpful error messages when the user enters invalid information.",
    image: "./form-capture.gif",
    link: "https://shauncy777.github.io/project-3/",
    github_link: "https://github.com/shauncy777/proj3-FSJS-interactiveForm",
  },
];

export const testimonials = [
  {
    quote:
      "Wow! Your script was quite refreshing to look at. I am very impressed in the extent of detail and cleanliness you've provided here. Your naming conventions for variables and functions are extremely clear and meaningful. You've commented where needed, particularly above your function signatures and blocks of variable initialization. It was nice to see that your script wasn't flooded with comments, as some do, but you let your code do most of the talking, as it was legible enough to do so. Going for a projects exceeds can definitely lengthen a scripts length, and it's good practice to try to keep shorter applications, such as this, between maybe two-hundred to three-hundred lines. You did just that!!! This was done with pure elegance, and you should be absolutely proud of this accomplishment.",
    image: "./Screen Shot 2022-02-10 at 4.05.30 PM.png",
    name: "Project Review",
    company: "Team Treehouse",
  },
  {
    quote:
      '"Perfect! No errors in the console, and your code comments help demonstrate at a glance how your code works and what it does. Your fellow developers and your future self will thank you for making a habit of adding smart code comments to your projects...Love it!! Your project displays the appropriate number of students per page and the search provides feedback when no students were found. You have set up some solid logic and done a great job building a concise, yet effective, search! Excellent work implementing the keyup event listener, this really makes for a smooth search and adds a lot to the user experience. Nicely done!"',
    image: "./Screen Shot 2022-02-10 at 4.05.30 PM.png",
    name: "Project Review",
    company: "Team Treehouse",
  },
  {
    quote:
      '"Shawn was a driven individual who looked for opportunities to lead new technology initiatives, giving actionable feedback and helping to support a smooth roll-out. He was a great teacher and was able to break the systems and tools down to make it easy to understand for all employees and team members. He took all coaching with a positive attitude and was always up to hearing how he could improve and took the steps to make it happen."',
    image: "./female_user_comment.svg",
    name: "Lolauna Lewis",
    company: "Prior Manager",
  },
  {
    quote:
      '"Shawn was a exceptional Manager with a can-do attitude. His ability to strategize through the most complex customer related problems is matched by his commitment to service the customer first. During the high peak season of retail, Shawn showed to be a strong manager by leading and training 20+ seasonal workers on the technology used at Nordstrom. He also led the training on new technology that were introduced by corporate. He was an essential part across all departments: customer service, logistics, and tech."',
    image: "./businesswoman_comment.svg",
    name: "Esmeralda Ortega-Rojas",
    company: "Prior Team Member",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Express.js",
  "jQuery",
  "Node",
  "SQL",
  "Git",
  "VS Code"
];
